import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class ShareTransactionLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.Nullable()
    public shareTransactionId: number | null = null;

    @Attributes.Nullable()
    public transactionRequestId: number | null = null;

    @Attributes.Date()
    public transactionDate: Date = new Date();

    @Attributes.Float()
    public amount: number = 0;

    @Attributes.Integer()
    public noOfShares: number = 0;

    public isLiquidity: boolean = false;

    public isTrade: boolean = false;

    // Client only properties / methods

    public get description() {
        if (this.isTrade) {
            if (this.isLiquidity) {
                return "Liquidity balance";
            } else {
                return "Sold to investors";
            }
        }
        return "";
    }
}